<template>
    <v-container fluid grid-list-md>
        <v-layout row wrap>
            <v-flex xs12>
                <v-card>
                     <v-card-text>
                         <v-container fluid v-if="reservation.show || 1">
                              <v-layout row wrap>
                                  <v-col cols="12" class="d-none d-md-flex">
                                       You have received a new reservation enquiry.  Please respond as soon as possible
                                  </v-col>
                                  
                                  <v-col cols="12" md="3">
                                      <v-btn class="ies-green" block v-on:click="chooseOfferQuote">Offer Quote</v-btn>
                                  </v-col>
                                  <v-col cols="12" md="3">
                                      <v-btn class="ies-green" block v-on:click="chooseAlternativeDates">Alternative Dates</v-btn>
                                  </v-col>
                                  <v-col cols="12" md="3">
                                      <v-btn class="ies-green" block v-on:click="chooseAlternativeRooms">Alternative Rooms</v-btn>
                                  </v-col>
                                  <v-col cols="12" md="3">
                                      <v-btn class="ies-coral" block v-on:click="chooseNoAvailability">No Availability</v-btn>
                                  </v-col>

                                  <v-col cols="12" v-if="option == 'offerQuote'">
                                      <ies-reservation-administration-offer-quote :reservationkey="reservationkey"></ies-reservation-administration-offer-quote>
                                  </v-col>
                                  <v-col cols="12" v-if="option == 'alternativeDates'">
                                      <ies-reservation-administration-alternative-dates :reservationkey="reservationkey"></ies-reservation-administration-alternative-dates>
                                  </v-col>
                                  <v-col cols="12" v-if="option == 'alternativeRooms'">
                                      <ies-reservation-administration-alternative-rooms :reservationkey="reservationkey"></ies-reservation-administration-alternative-rooms>
                                  </v-col>
                                  <v-col cols="12" v-if="option == 'noAvailability'">
                                      <ies-reservation-administration-no-availability :reservationkey="reservationkey"></ies-reservation-administration-no-availability>
                                  </v-col>
                              </v-layout>
                          </v-container>
                      </v-card-text>

                 </v-card>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
    /**
     * A Vue component dedicated to letting the user manage a reservations
     * by the ID specified
     *
     * Props:
     *     int 'reservationkey' - The ID of the reservation to display
     */

    import axios from 'axios';
    export default {
        name: 'hotel-reservation-enquiry',
        props: ['reservationkey'],
        data () {
            return {
                reservation: {},
                option: '',
            }
        },
        methods: {

            loadReservation(){
                axios.get('/api/reservations/' + this.reservationkey + '/administration')
                .then(function(response){
                    this.reservation = response.data;
                }.bind(this));
            },

            chooseOfferQuote(){
                this.option = 'offerQuote';
            },

            chooseAlternativeRooms(){
                this.option = 'alternativeRooms';
            },

            chooseAlternativeDates(){
                this.option = 'alternativeDates';
            },

            chooseNoAvailability(){
                this.option = 'noAvailability';
            }
        },

        /**
         * Once mounted this component needs to load the reservation specified
         */
        mounted() {
            this.loadReservation();
        },

        computed: {}
    }
</script>
